module.exports = __webpack_public_path__ + "static/media/mev.094bdf33.png";